import _ from 'lodash'

import CONSTANTS from './paymentConfirmation.constants'

class PaymentConfirmationController {
    /** @ngInject */
    constructor(ErrorCatcher) {
        this.ErrorCatcher = ErrorCatcher
    }

    $onInit() {
        if (this.transaction.transactionStatus === 'success' && this.transaction.transactionId.split('_')[0] === 'DEPOSIT') {
            this.viewState = 'state-payment-security-deposit-success'
        } else if (this.transaction.transactionStatus === 'success') {
            this.viewState = 'state-payment-success'
        } else if (this.transaction.transactionStatus === 'failure') {
            this.viewState = 'state-payment-failure'
            this.errorMsg = this.getErrorMsgFromCode(this.transaction)
            this.ErrorCatcher.catchErrorWithoutRedirect({
                status: this.ErrorCatcher.WEBSITE_ERROR_STATUS,
                transaction: this.transaction,
                errorMsg: this.errorMsg,
            })
        } else {
            this.viewState = 'state-payment-default'
        }
    }

    getErrorMsgFromCode(transaction) {
        let result = CONSTANTS.defaultErrorMsg
        if (transaction.cardOperationResult) {
            result = _.get(CONSTANTS.cardOperationResultMapping, transaction.cardOperationResult, CONSTANTS.defaultErrorMsg)
        } else if (transaction.transactionErrorCode) {
            result = _.get(CONSTANTS.transactionErrorCodeMapping, transaction.transactionErrorCode, CONSTANTS.defaultErrorMsg)
        }
        // Assign default label if undefined in result
        return _.assign({}, CONSTANTS.defaultErrorMsg, result)
    }
}

export default {
    template: require('./paymentConfirmation.jade')(),
    controller: PaymentConfirmationController,
    bindings: {
        transaction: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/paymentConfirmation/paymentConfirmation.component.js